import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { ProfileCard, ProfileCardData } from '@galaxy/crm/static';

@Component({
  selector: 'crm-profile-cards-panel',
  imports: [CommonModule, MatExpansionModule],
  templateUrl: './profile-cards-panel.component.html',
  styleUrls: ['./association-panel-shared.scss', 'profile-cards-panel.component.scss'],
})
export class ProfileCardsPanelComponent {
  cardData = input<ProfileCardData>();
  cards = input<ProfileCard[]>();
}
